import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-item-detail-form-actions',
  template: `
    <app-spinner-form-actions *ngIf="sendingForm && showSaveItem"></app-spinner-form-actions>

    <!-- Cancel -->
    <button
      type="button"
      class="btn"
      [ngClass]="buttonsClass"
      [disabled]="sendingForm"
      (click)="cancel()"
    >
      <i class="fa fa-undo"></i> {{ 'CANCEL' | translate }}
    </button>

    <!-- View -->
    <span *ngIf="viewMode">
      <!-- <button type="button" class="btn" [ngClass]="buttonsClass" (click)="cancel()">
        <i class="fa" [ngClass]="!isModal ? 'fa-angle-left' : 'fa-undo'"></i>
        {{ !isModal ? 'Back' : 'Cancel' }}
      </button> -->

      <button
        type="button"
        class="btn btn-warning"
        [ngClass]="buttonsClass"
        [disabled]="disableEditItem"
        (click)="edit()"
        *ngIf="showEditItem"
      >
        <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
      </button>
    </span>

    <!-- Create / Update -->
    <span *ngIf="!viewMode">
      <button
        type="button"
        class="btn btn-primary"
        [ngClass]="buttonsClass"
        [disabled]="disableSaveItem"
        (click)="save()"
        *ngIf="showSaveItem"
      >
        <i class="fa fa-save"></i> {{ (createMode ? saveItemLabel : updateItemLabel) | translate }}
      </button>
    </span>
  `,
})
export class ItemDetailFormActionsComponent {
  @Input() buttonsClass: string = 'btn-lg';
  @Input() createMode: boolean;
  @Input() disableEditItem: boolean;
  @Input() disableSaveItem: boolean;
  @Input() isModal: boolean = false;
  @Input() saveItemLabel: string = 'Create';
  @Input() sendingForm: boolean;
  @Input() showEditItem: boolean = true;
  @Input() showSaveItem: boolean = true;
  @Input() updateItemLabel: string = 'Update';
  @Input() viewMode: boolean = false;

  @Output() private canceled = new EventEmitter();
  @Output() private edited = new EventEmitter();
  @Output() private saved = new EventEmitter();

  cancel() {
    this.canceled.emit();
  }

  edit() {
    this.edited.emit();
  }

  save() {
    this.saved.emit(); // isFormValid
  }
}

// OnInit;
// implements OnInit

// export const ItemDetailStandardActionsComponent = {
//   templateUrl:
//     './app/_components/item-detail-standard-actions/item-detail-standard-actions.component.html',
//   bindings: {
//     viewMode: '<',
//     createMode: '<',
//     editItem: '&',
//     editItemShow: '<',
//     editItemDisabled: '<',
//     saveItem: '&',
//     saveItemShow: '<',
//     saveItemDisabled: '<',
//     saveItemLabel: '@',
//     updateItemLabel: '@',
//     cancel: '&',
//     sendingForm: '<',
//     buttonsClass: '@',
//     isModal: '<',
//   },
//   controller: function () {},
//   controllerAs: 'vm',
// };
